<template>
  <section>
    <div class="form-group">
      <label>Coupon Code</label>
      <multiselect id="couponsMultiselect"
                   :options="coupons"
                   v-model="selectedCouponTemp"
                   :allow-empty="false"
                   placeholder="Select Coupon"
                   track-by="couponCode"
                   label="couponCode"
                   :max-height="150">
      </multiselect>
    </div>
  </section>
</template>

<script>
import Multiselect from "vue-multiselect";
import {getAllCouponsUsingWildCard} from "../../api/coupons";

export default {
  name: "SearchCouponByCouponCode",
  components: {Multiselect},
  data () {
    return {
      selectedCouponTemp: null,
      coupons: [],
    }
  },
  watch: {
    selectedCouponTemp (val) {
      this.$emit('selectedCoupon', val);
    }
  },
  mounted() {
    this.getCoupon()
  },
  methods: {
    async searchCoupon () {
      let coupon_code = $("#couponsMultiselect").val();
      if(coupon_code !== "" && coupon_code.length > 2) {
        this.coupons = [];
        let params = new URLSearchParams();
        params.append("coupon_code", coupon_code);
        let allCouponsResp = await getAllCouponsUsingWildCard(params).catch(ex => {
          this.showErrorMessage(ex);
        });
        this.coupons = allCouponsResp.data;
      }
    },
    getCoupon() {
      let self = this;
      $('#couponsMultiselect').keydown(function(event){
        var id = event.key || event.which || event.keyCode || 0;
        if (id == 13 || id=='Enter') {
          self.searchCoupon();
        }
      });
    }
  }
}
</script>

<style scoped>

</style>